<div mat-dialog-content class="dialog-content">
  <div class="dialog-header p-2">
    <h2 mat-dialog-title class="dialog-title" [style.color]="resolveBackgroundColor(data.iconColor)">{{ data.title }}</h2>
    <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
  </div>

  
   <!-- <div class="icon-container">
      <mat-icon class="dialog-icon" [color]="isThemeColor(data.iconColor) ? data.iconColor : ''"
      [style.color]="!isThemeColor(data.iconColor) ? data.iconColor : null">{{ data.icon }}</mat-icon>
    </div> -->
    <!-- <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2> -->
    <p class="dialog-message" [innerHTML]="data.message"></p>
    <div *ngIf="data.showDropdown && data.options?.length" style="margin: 12px 0;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Select Component</mat-label>
        <mat-select [(ngModel)]="selectedOption">
          <mat-option *ngFor="let opt of data.options" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="data.isCheckbox">

      <div *ngFor="let item of this.dynamicFilterService.dynamicProcessMandatoryColumns" class="checkbox-container">
        <input
          type="checkbox"
          [id]="item"
          [checked]="formValues[item]"
          (change)="onCheckboxChange(item, $event)"
          class="checkbox-input"
        />
        <label [for]="item" class="checkbox-label">{{ item }}</label>
      </div>
      
    </div>
    <div mat-dialog-actions align="center" style="padding: 0;">
        <button *ngIf="data.cancelText" mat-button (click)="onCancel()" class="cancel btn-size">{{ data.cancelText }}</button>
        <button mat-raised-button  class="btn-size" (click)="onConfirm()" style="color: white;"
        [style.background]="!isThemeColor(data.iconColor) ? data.iconColor : null">{{ data.confirmText }}</button>
      </div>
</div>
  
  
  